import { EcosystemItemTag, EcosystemItemType } from '~/enums/ecosystem.enum';
import { getEnv } from '~/env';
import { joinURL } from 'ufo';

const ECOSYSTEM_APPS_URL = joinURL(
  getEnv('NEXT_PUBLIC_JOC_RESOURCE_BASE_URL') || '',
  'ecosystem',
  'index.json',
);

export type EcosystemApp = {
  name: {
    [lang: string]: string;
  };
  description: {
    [lang: string]: string;
  };
  types: EcosystemItemType[];
  image: string;
  url: string;
  tags?: EcosystemItemTag[];
};

export const fetchEcosystemApps = async (): Promise<EcosystemApp[]> => {
  const response = await fetch(ECOSYSTEM_APPS_URL);
  const data = await response.json();
  return data.projects;
};
